import React, {Component} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'

import Home from './Home'
import Faq from './Faq'
import Blog from './Blog'
import Post from './Blog/Post'
import Careers from './Careers'
import Vacancy from './Vacancy'
import Pricing from './Pricing'
import FreeTrial from './FreeTrial'
import Login from './Login'
import Signup from './Signup'
import SignupComplete from './Signup/Complete'
import PasswordRecovery from './PasswordRecovery'
import PasswordRecoverySuccess from './PasswordRecoverySuccess'
import {TermsAndConditions, PrivacyPolicy, Contact} from 'Components/Public'

class Routes extends Component {
  render() {
    return(
      <Switch>
        <Route path='/' exact component={Home}/>
        <Route path='/faq' exact component={Faq}/>
        <Route path='/blog' exact component={Blog}/>
        <Route path='/blog/post/:index' exact component={Post}/>
        <Route path='/careers' exact component={Careers}/>
        <Route path='/careers/:vacancy' exact component={Vacancy}/>
        <Route path='/pricing' exact component={Pricing}/>
        <Route path='/free-trial' exact component={FreeTrial}/>
        <Route path='/login' exact component={Login}/>
        <Route path='/signup' exact component={Pricing}/>
        <Route path='/signup/plan/:id' exact component={Signup}/>
        <Route path='/signup-complete' exact component={SignupComplete}/>
        <Route path='/password-recovery' exact component={PasswordRecovery}/>
        <Route path='/password-recovery/success' exact component={PasswordRecoverySuccess}/>
        <Route path='/terms-and-conditions' exact component={TermsAndConditions}/>
        <Route path='/privacy-policy' exact component={PrivacyPolicy}/>
        <Route path='/contact' exact component={Contact}/>
        <Route render={() => (
          <Redirect to='/'/>
        )}/>
      </Switch>
    )
  }
}

export default Routes
